import React, { useState, useEffect } from 'react';
import { http } from "~/services/http";
import {ContactForm} from "~/Pages/Contact/Contact";

const HostContacts = (props) => {

    const [host, setHost] = useState({});

    useEffect(() => {

        http.get('host/' + props.match.params.uuid).then(res => {
            setHost(res.data);
        });

    }, []);

    if (!host) {
        return <></>;
    }

    return <ContactForm event={host.event} />
}


export default HostContacts;
